"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIONS = void 0; // 协议 action 列表

exports.ACTIONS = {
  closeWeb: 'closeWeb',
  fullScreen: 'fullScreen',
  toNextPage: 'toNextPage',
  logout: 'logout',
  toHomeworkComment: 'toHomeworkComment',
  updateNavLeftBtnCallbackCode: 'updateNavLeftBtnCallbackCode',
  share: 'share',
  getHllUserInfo: 'getHllUserInfo'
};